import {
  AdjustmentsHorizontalIcon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  CubeIcon,
  HomeIcon,
  PlayCircleIcon,
  Squares2X2Icon,
} from '@heroicons/react/24/outline';

import { Sidebar } from '@/components/layout/Sidebar';
import { CanvasRoutes, RouterConfig, Routes } from '@/configs/routes';

const items = Routes.filter((r) => r.showInNavigation && r.path.startsWith('/decisions/'));

const iconMap = {
  [RouterConfig[CanvasRoutes.DecisionsActivePlanning].path]: HomeIcon,
  [RouterConfig[CanvasRoutes.DecisionsBacktests].path]: ClipboardDocumentListIcon,
  [RouterConfig[CanvasRoutes.DecisionsExecute].path]: PlayCircleIcon,
  [RouterConfig[CanvasRoutes.DecisionsValueOpportunity].path]: ChartBarIcon,
  [RouterConfig[CanvasRoutes.DecisionsProductStockingLocations].path]: CubeIcon,
  [RouterConfig[CanvasRoutes.DecisionsCanvas].path]: Squares2X2Icon,
  [RouterConfig[CanvasRoutes.DecisionsPolicies].path]: AdjustmentsHorizontalIcon,
};

// Every page here now belongs to the Production Quantity & Timing domain, Decision Canvas
// included, so the header sits above the first nav item and covers the whole list.
//
// The label is duplicated from each route's `breadcrumbGroup` rather than read from it,
// because `dividers` is a path→label map. Driving the sidebar off `breadcrumbGroup` needs a
// change to the shared Sidebar, which is deliberately deferred to a single PR covering all
// shared-component work — along with the indented, two-level nesting still pending product
// review.
const dividers = {
  [RouterConfig[CanvasRoutes.DecisionsActivePlanning].path]: 'Production Quantity & Timing',
};

export function DecisionsSidebar() {
  return <Sidebar label="Decisions" items={items} iconMap={iconMap} dividers={dividers} depth={1} />;
}
